import { OnboardingProTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useNavigate } from '@frontend/weave-router';
import { CALL_INTEL_PATH } from '../constant';
import { useProOnboardingActionShallowStore } from '../hooks/use-pro-onboarding-action-store';
import type { TaskAction, TaskActionArgs } from '../types';

export function useProReviewConversationAnalysisAction({ onClose }: TaskActionArgs): TaskAction {
  const navigate = useNavigate();

  const { eligibility, isEligibilityResolved, setPendingTask } = useProOnboardingActionShallowStore(
    'eligibility',
    'isEligibilityResolved',
    'setPendingTask'
  );

  const isEnabled = !isEligibilityResolved || eligibility.hasEligibleCallInsightPanel;

  return {
    isEnabled,
    isLoading: false,
    onSelect: () => {
      if (!isEnabled) return;
      setPendingTask(OnboardingProTask.PRO_TASK_REVIEW_CONVERSATION_ANALYSIS);
      navigate({ to: CALL_INTEL_PATH });
      onClose();
    },
  };
}
